import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ChannelTitleTooltipProps {
  title: string;
  isVisible: boolean;
  triggerRef: React.RefObject<HTMLDivElement | null>;
}

const ChannelTitleTooltip: React.FC<ChannelTitleTooltipProps> = ({
  title,
  isVisible,
  triggerRef,
}) => {
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      
      // Find the sidebar element to get its right edge
      const sidebar = document.querySelector('[data-sidebar]') as HTMLElement;
      const sidebarRight = sidebar ? sidebar.getBoundingClientRect().right : triggerRect.right;
      const spacing = 8; // Space between sidebar and tooltip
      
      setTooltipPosition({
        top: triggerRect.top + (triggerRect.height / 2), // Center vertically with trigger
        left: sidebarRight + spacing, // Position after sidebar ends
      });
    }
  }, [isVisible, triggerRef]);

  if (!isVisible) return null;

  return createPortal(
    <div
      ref={tooltipRef}
      className="fixed z-99999 pointer-events-none transform -translate-y-1/2"
      style={{
        top: `${tooltipPosition.top}px`,
        left: `${tooltipPosition.left}px`,
      }}
    >
      <div className="bg-white text-gray-800 text-sm px-3 py-2 rounded shadow-lg border border-gray-200 max-w-xs wrap-break-word whitespace-pre-line">
        {title}
        {/* Arrow pointing to the trigger */}
        <div className="absolute right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-white"></div>
      </div>
    </div>,
    document.body
  );
};

export default ChannelTitleTooltip;
